import { Component, Input } from '@angular/core';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'app-post-text',
  templateUrl: "post-text.component.html",
  styleUrls: ["post-text.component.css"]
})
export class PostTextComponent implements OnInit {
  @Input() text: string;
  @Input() textExposedHide = '...';
  @Input() maxLength = 200;

  public html: string;
  public isCollapsable: boolean;
  constructor() {

  }
  ngOnInit() {


    let text = this.text;
    this.text = this.text.replace('#şikayetimvar', '');
    this.text = this.text.replace('#bunuçoksevdim', '');
    this.text = this.text.replace('#markamaönerim', '');
    this.text = this.text.replace('#benimtavsiyem', '');


    if (this.text && this.text.length > this.maxLength) {
      text = this.text.substring(0, this.maxLength);
      this.isCollapsable = true;
    }
    this.html = text;
    this.html = this.html.replace('#şikayetimvar', '');
    this.html = this.html.replace('#bunuçoksevdim', '');
    this.html = this.html.replace('#markamaönerim', '');
    this.html = this.html.replace('#benimtavsiyem', '');


  }
  readMore() {
    this.html = this.text;
    this.isCollapsable = false;
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/post-text/post-text.component.ts